__turbopack_context__.v({
  "banner": "Sertificate-module-scss-module__LuFsOa__banner",
  "bannerImage": "Sertificate-module-scss-module__LuFsOa__bannerImage",
  "content": "Sertificate-module-scss-module__LuFsOa__content",
  "contentList": "Sertificate-module-scss-module__LuFsOa__contentList",
  "contentTitle": "Sertificate-module-scss-module__LuFsOa__contentTitle",
  "contentTop": "Sertificate-module-scss-module__LuFsOa__contentTop",
  "contentValue": "Sertificate-module-scss-module__LuFsOa__contentValue",
  "root": "Sertificate-module-scss-module__LuFsOa__root",
  "title": "Sertificate-module-scss-module__LuFsOa__title",
});
